(function(){
  fragranceFinder = {
    selector: {
        options: ".js-question-option",
        quizMainDiv: ".js-quiz-main",
        optionLists: ".js-option-list",
        selectedText: ".js-selected-text",
        productMetafieldJson: ".js-product-metafield",
        fragranceFinderButton: ".js-findfragrance-button",
        startAgainButton: ".js-start-again",
        fragranceSidebar: ".finder-sidebar"
    },
    init: function(){
        this.questionOptions = document.querySelectorAll(this.selector.options);
        this.quizMianElement = document.querySelectorAll(this.selector.quizMainDiv);
        this.optionListsElement = document.querySelectorAll(this.selector.optionLists);
        this.selectedTextElement = document.querySelector(this.selector.selectedText);
        this.productMetafieldJsonElement = document.querySelectorAll(this.selector.productMetafieldJson);
        this.fragranceFinderButton = document.querySelector(this.selector.fragranceFinderButton);
        this.startAgainButton = document.querySelector(this.selector.startAgainButton);
        this.fragranceSidebar = document.querySelector(this.selector.fragranceSidebar);
        this.currentStep = 1;
        this.bindEvent();
        
    },
    bindEvent: function(){
        const _this = this;
        this.questionOptions.forEach((option) => option.addEventListener("click",_this.selectOptions.bind(this),true));
        this.fragranceFinderButton.addEventListener("click",_this.findFragrance.bind(this));
        this.startAgainButton.addEventListener("click",_this.startAgain.bind(this));
        this.fragranceSidebar.addEventListener("click",(event)=> event.target.closest(this.selector.fragranceSidebar).classList.toggle("active"));
       let elementInterval =  setInterval(() => {
         
        if(document.querySelectorAll(".js-text-button").length > 7){
          clearInterval(elementInterval);
        }
        document.querySelectorAll(".js-text-button").forEach((button)=>{
          button.querySelector("a").addEventListener("click",_this.stepShowHide.bind(this),true);
        });
       },3000);
       this.loadFromMemory();
      
       
    },
    loadFromMemory: function(){
      const _this = this;
      const fragranceStepValue = [];
        if(localStorage.getItem("current-step")){
            let currentActiveStep = parseInt(localStorage.getItem("current-step"));
            currentActiveStep = currentActiveStep - 1;
            this.quizMianElement[currentActiveStep].classList.remove("hidden");
            this.quizMianElement.forEach((element,index) => {
              if(index !== currentActiveStep){
                  element.classList.add("hidden");
              }
          });
        }
        for(i=1;i<=7;i++){
          fragranceStepValue.push(localStorage.getItem(`fragrance-match-step-${i}`));
          if(localStorage.getItem(`fragrance-match-step-${i}`) != null){

            this.selectedTextInsert(i,localStorage.getItem(`fragrance-match-step-${i}`));
            this.questionOptions.forEach((option) => {
              if(option.getAttribute("data-option") === localStorage.getItem(`fragrance-match-step-${i}`)){
                option.classList.add("selected");
              }
            });
          }
        }
       if(fragranceStepValue[6] !== null){
        document.querySelector(".js-findfragrance-button").classList.remove("hidden");
       }
      
    },
    selectOptions: function(event){
        const _this = this;
        const optionValue = event.target.closest(this.selector.options).getAttribute("data-option");
        const index = parseInt(event.target.closest(this.selector.quizMainDiv).getAttribute("data-index"));
        event.target.closest(this.selector.optionLists).querySelectorAll(this.selector.options).forEach((option)=> option.classList.remove("selected"));
        if(event.target.closest(this.selector.options).classList.contains("selected") == false){

          event.target.closest(this.selector.options).classList.add("selected");
        }
        _this.selectedTextInsert(index,optionValue);
        if(index < 7){
          this.quizMianElement[index].classList.remove("hidden");
          this.quizMianElement[index-1].classList.add("hidden");  
        }
        if(index < 7){
          _this.currentStep =  _this.currentStep  + 1;
        }
        if(index === 7){
          document.querySelector(".js-findfragrance-button").classList.remove("hidden");
        }
        localStorage.setItem(`fragrance-match-step-${index}`,optionValue);
        localStorage.setItem("current-step", index);
    },
    selectedTextInsert: function(index,optionValue){
      const _this = this;
      if(index === 1){
        if(_this.selectedTextElement.querySelector(".js-first-step") == null){

          let newElement = `<span class="js-first-step js-text-button">
            <a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a>, 
          </span>`
          _this.selectedTextElement.insertAdjacentHTML("beforeend",newElement);
        }else{
          _this.selectedTextElement.querySelector(".js-first-step").innerHTML = `<a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a>,`
        }
      }
      if(index === 2){
        if(_this.selectedTextElement.querySelector(".js-second-step") == null){
          let newElement = `<span class="js-second-step js-text-button">that can be worn 
            <a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a>
            ,
          </span> `
          _this.selectedTextElement.insertAdjacentHTML("beforeend",newElement);
        }else{
          _this.selectedTextElement.querySelector(".js-second-step").innerHTML = `that can be worn 
            <a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a>
            ,`
        }
      } 
      if(index === 3){
        if(_this.selectedTextElement.querySelector(".js-third-step") == null){
          let newElement = `<span class="js-third-step js-text-button">that compliments a 
            <a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a> style,
          </span> `
          _this.selectedTextElement.insertAdjacentHTML("beforeend",newElement);
        }else{
          _this.selectedTextElement.querySelector(".js-third-step").innerHTML = `that compliments a 
            <a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a> style,`
        }
      }
      if(index === 4){
        if(_this.selectedTextElement.querySelector(".js-fourth-step") == null){
          let newElement = `<span class="js-fourth-step js-text-button"> has an 
            <a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a> scent,
            </span>`
          _this.selectedTextElement.insertAdjacentHTML("beforeend",newElement);
        }else{
          _this.selectedTextElement.querySelector(".js-fourth-step").innerHTML = ` has a 
            <a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a> scent,`
        }
      }
      if(index === 5){
        if(_this.selectedTextElement.querySelector(".js-fifth-step") == null){
        let newElement = `<span class="js-fifth-step js-text-button"> with a 
          <a href="#" class="animated-link" data-index="${index}">
              <span class="stack">
                  <span class="text">${optionValue}</span>
              </span>
          </a> feel,
          </span>`
        _this.selectedTextElement.insertAdjacentHTML("beforeend",newElement);
        }else{
          _this.selectedTextElement.querySelector(".js-fifth-step").innerHTML = ` with a 
          <a href="#" class="animated-link" data-index="${index}">
              <span class="stack">
                  <span class="text">${optionValue}</span>
              </span>
          </a> feel,`
        }
      }
      if(index === 6){
        if(_this.selectedTextElement.querySelector(".js-sixth-step") == null){
        let newElement = `<span class="js-sixth-step js-text-button"> that is reminicent of 
          <a href="#" class="animated-link" data-index="${index}">
              <span class="stack">
                  <span class="text">${optionValue}</span>
              </span>
          </a>,
          </span>`
        _this.selectedTextElement.insertAdjacentHTML("beforeend",newElement);
        }else{
          _this.selectedTextElement.querySelector(".js-sixth-step").innerHTML = ` that is reminicent of 
          <a href="#" class="animated-link" data-index="${index}">
              <span class="stack">
                  <span class="text">${optionValue}</span>
              </span>
          </a>,`
        }
      }
      if(index === 7){
        if(_this.selectedTextElement.querySelector(".js-seven-step") == null){
        let newElement = `<span class="js-seven-step js-text-button">but at the heart makes you feel 
          <a href="#" class="animated-link" data-index="${index}">
              <span class="stack">
                  <span class="text">${optionValue}</span>
              </span>
          </a>.
          </span>`
        _this.selectedTextElement.insertAdjacentHTML("beforeend",newElement);
        }else{
          _this.selectedTextElement.querySelector(".js-seven-step").innerHTML = `but at the heart makes you feel <a href="#" class="animated-link" data-index="${index}">
                <span class="stack">
                    <span class="text">${optionValue}</span>
                </span>
            </a>.`
        }
      }
    },
    stepShowHide: function(event){
      const _this = this;
      const index = parseInt(event.target.closest("a").getAttribute("data-index"));
      _this.quizMianElement[index - 1].classList.remove("hidden");
      const newIndex = index - 1;
      
      _this.quizMianElement.forEach((hideEleme,indexh)=>{
        if(indexh != newIndex){
          hideEleme.classList.add("hidden");
        }else{
           hideEleme.classList.remove("hidden");
        }
      });
      _this.currentStep = index;
      localStorage.setItem("current-step", index);
    },
    findFragrance: function(event){
      const _this = this;
      const allValue = [];
      const allPopularity = [];
      _this.productMetafieldJsonElement.forEach((jsonDiv)=>{
        const productJson = JSON.parse(jsonDiv.innerText);
        const optionOneValue = localStorage.getItem(`fragrance-match-step-1`);
        const optionTwoValue = localStorage.getItem(`fragrance-match-step-2`);
        const optionThreeValue = localStorage.getItem(`fragrance-match-step-3`);
        const optionFourValue = localStorage.getItem(`fragrance-match-step-4`);
        const optionFiveValue  = localStorage.getItem(`fragrance-match-step-5`);
        const optionSixValue = localStorage.getItem(`fragrance-match-step-6`);
        const optionSevenValue = localStorage.getItem(`fragrance-match-step-7`);
        const splitOpeionOneValue = optionOneValue.split('-');
    
        if(productJson[splitOpeionOneValue[1]] != undefined && productJson[optionTwoValue] != undefined && productJson[optionThreeValue] != undefined && productJson[optionFourValue] != undefined && productJson[optionFiveValue] != undefined && productJson[optionSixValue] != undefined && productJson[optionSevenValue] != undefined){
            
          allValue.push(parseInt(productJson[splitOpeionOneValue[1]])+parseInt(productJson[optionTwoValue])+parseInt(productJson[optionThreeValue])+parseInt(productJson[optionFourValue])+parseInt(productJson[optionFiveValue])+parseInt(productJson[optionSixValue])+parseInt(productJson[optionSevenValue]));
          allPopularity.push(productJson.popularity)
        }
      });
      const maxValue = Math.max(...allValue);
      const indexOfMaxValue = allValue.indexOf(maxValue);
      const multiMaxValue = allValue.filter((element) => element === maxValue);

      const findPositions = (first, second) => {
        const indicies = [];
        first.forEach((element, index) => {
           if(second.includes(element)){
              indicies.push(index);
           };
        });
        return indicies;
     };
     const indexOfMultiMaxValue = findPositions(allValue,multiMaxValue);
     const multiPopularValue = [];
     let map = new Map();
     if(indexOfMultiMaxValue.length >= 2){
      for(let i of indexOfMultiMaxValue){
        multiPopularValue.push({key: i , value:allPopularity[i]});
      }
      let maxValue = Math.max.apply(null,
        multiPopularValue.map(function (o) { return o.value; }));
      let index = multiPopularValue.map(e => e.value == maxValue ? e.key : null);
      for(let inx in index){
        if(inx != null){   
          const url = _this.productMetafieldJsonElement[inx].getAttribute("data-product-url"); 
          const variantId = _this.productMetafieldJsonElement[inx].getAttribute("data-variant-id"); 
          if(variantId != ''){

            window.location = `${location.origin}${url}?variant=${variantId}`;
          }else{
            window.location = `${location.origin}${url}`;
          }
        }
      }
     }else{
      const url = _this.productMetafieldJsonElement[indexOfMaxValue].getAttribute("data-product-url");
      const variantId = _this.productMetafieldJsonElement[indexOfMaxValue].getAttribute("data-variant-id"); 
      if(variantId != ''){

        window.location = `${location.origin}${url}?variant=${variantId}`;
      }else{
        window.location = `${location.origin}${url}`;
      }
      
     }


    },
    startAgain: function(event){
      localStorage.removeItem("current-step");
      for(i=1;i<=7;i++){
        localStorage.removeItem(`fragrance-match-step-${i}`)
      }
      window.location.reload();
    }
  }
  fragranceFinder.init();
})();